<template>
  <div class="case-card" @click="$emit('open', caseData)">
    <div class="case-card-header">
      <div class="case-card-icon">
        <i class="fa-solid fa-briefcase"></i>
      </div>
      <div class="case-card-info">
        <span class="case-card-name" :title="caseData.name">{{ caseData.name }}</span>
        <span v-if="caseData.description" class="case-card-description" :title="caseData.description">
          {{ caseData.description }}
        </span>
        <span v-else class="case-card-description">Sem descrição</span>
      </div>
      <span class="case-card-status" :class="isActive ? 'case-card-status-active' : 'case-card-status-inactive'">
        {{ isActive ? "Ativo" : "Inativo" }}
      </span>
    </div>

    <div class="case-card-tags">
      <span class="case-card-tag" v-if="caseData.barCode">
        <i class="fa-solid fa-barcode"></i>
        {{ caseData.barCode }}
      </span>
      <span class="case-card-tag" v-if="caseData.rfid">
        <i class="fa-solid fa-tower-broadcast"></i>
        {{ caseData.rfid }}
      </span>
    </div>

    <div class="case-card-actions">
      <span v-b-tooltip.hover title="Patrimônios na case" class="case-card-total">
        <i class="fa-solid fa-boxes-stacked"></i>
        {{ totalItems }}
      </span>

      <div class="case-card-buttons">
        <div v-b-tooltip.hover title="Abrir Case" class="case-card-btn" @click.stop="$emit('open', caseData)">
          <i class="fa-solid fa-arrow-up-right-from-square"></i>
        </div>
        <div v-b-tooltip.hover title="Editar Dados" class="case-card-btn" @click.stop="$emit('edit', caseData)">
          <i class="fa-solid fa-pen-to-square"></i>
        </div>
        <div class="case-card-delete" @click.stop>
          <div v-if="!confirmingDelete" v-b-tooltip.hover title="Excluir Case"
            class="case-card-btn case-card-btn-danger" @click="confirmingDelete = true">
            <i class="fa-solid fa-trash"></i>
          </div>
          <div v-else class="case-card-confirm">
            <div class="case-card-btn case-card-btn-confirm" v-b-tooltip.hover title="Confirmar exclusão"
              @click="$emit('delete', caseData)">
              <i class="fa-solid fa-circle-check"></i>
            </div>
            <div class="case-card-btn case-card-btn-danger" v-b-tooltip.hover title="Cancelar"
              @click="confirmingDelete = false">
              <i class="fa-solid fa-xmark"></i>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "CaseCard",
  props: {
    caseData: { type: Object, required: true },
  },
  data() {
    return {
      confirmingDelete: false,
    };
  },
  computed: {
    isActive() {
      return this.caseData.status == 1;
    },
    totalItems() {
      return this.caseData.totalItems || 0;
    },
  },
};
</script>

<style scoped>
.case-card {
  background: var(--bg-base);
  border: 1px solid var(--border-color);
  border-radius: 12px;
  width: 320px;
  padding: 16px 20px;
  cursor: pointer;
  transition: box-shadow 0.15s, border-color 0.15s, transform 0.15s;
}

.case-card:hover {
  box-shadow: var(--shadow-sm);
  transform: translateY(-1px);
}

.case-card-header {
  display: flex;
  align-items: flex-start;
  gap: 12px;
  margin-bottom: 12px;
}

.case-card-icon {
  width: 38px;
  height: 38px;
  border-radius: 10px;
  background: rgba(87, 118, 150, 0.1);
  display: flex;
  align-items: center;
  justify-content: center;
  color: var(--color-brand);
  font-size: 16px;
  flex-shrink: 0;
}

.case-card-info {
  display: flex;
  flex-direction: column;
  gap: 2px;
  min-width: 0;
  flex: 1;
}

.case-card-name {
  font-size: 15px;
  font-weight: 500;
  color: var(--text-primary);
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.case-card-description {
  font-size: 12px;
  color: var(--text-muted);
  font-style: italic;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.case-card-status {
  font-size: 11px;
  font-weight: 600;
  border-radius: 999px;
  padding: 2px 10px;
  flex-shrink: 0;
  color: var(--text-inverse);
}

.case-card-status-active {
  background: var(--color-success);
}

.case-card-status-inactive {
  background: var(--text-muted);
}

.case-card-tags {
  display: flex;
  flex-wrap: wrap;
  gap: 6px;
  margin-bottom: 12px;
  min-height: 20px;
}

.case-card-tag {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  font-size: 12px;
  color: var(--text-secondary);
  background: var(--bg-elevated);
  border-radius: 999px;
  padding: 3px 10px;
  max-width: 100%;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.case-card-actions {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding-top: 12px;
  border-top: 1px solid var(--border-subtle);
}

.case-card-total {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 3px 10px;
  border-radius: 999px;
  background: var(--bg-elevated);
  color: var(--text-secondary);
  font-size: 12px;
  font-weight: 600;
}

.case-card-buttons {
  display: flex;
  align-items: center;
  gap: 14px;
}

.case-card-btn {
  font-size: 16px;
  cursor: pointer;
  color: var(--text-muted);
  transition: color 0.15s;
}

.case-card-btn:hover {
  color: var(--color-brand);
}

.case-card-btn-danger {
  color: var(--color-danger);
}

.case-card-btn-danger:hover {
  color: var(--color-danger);
}

.case-card-btn-confirm {
  color: var(--color-success);
}

.case-card-btn-confirm:hover {
  color: var(--color-success);
}

.case-card-delete {
  display: flex;
}

.case-card-confirm {
  display: flex;
  align-items: center;
  gap: 10px;
}
</style>
